import logger from "debug";
import ns from "@lib/log/ns";
export const log = (tag: string, formatter: any, ...args: Array<any>) => {
  if (!ns[tag]) {
    ns[tag] = logger(tag);
  }
  ns[tag](formatter, ...args);
};
globalThis.LOG = log;
export default log;